export function getId(entity: string | { id?: string; value?: string }): string {
  if (!entity) {
    return undefined;
  }
  if (typeof entity === 'string') {
    return entity;
  }

  return entity.id || entity.value || undefined;
}
